<style>
  .k-message{
    padding: 10px;
    box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
    border-radius: 1rem;
    margin-bottom: 10px;
    color: white;
    font-size: 14px;
  }
  .info{
    background-color: var(--bs-blue);
  }
  .error{
    background-color: var(--bs-red);
  }
  .success{
    background-color: var(--bs-success);
  }
  .warning{
    background-color: var(--bs-warning);
  }
</style>

<template>
  <div class="k-message" :class="messageType">{{message}}</div>
</template>

<script>

export default {
  name: 'KMessageHandler',
  components: {
  },
  props: {
    messageType: {
      type: String,
      default:"info"
    },
    message:{
      type:String,
      default:""
    },
    messageId:{
      type:String,
      default:""
    }
  },
  mounted() {
    setTimeout(()=>{
      this.$store.dispatch('removeMessage', {messageId:this.messageId});
    }, 5000)
  },
};
</script>